// Base Url of the system

import axios from "axios";
import { notification } from "antd";
import { handleSessionExpired } from "lib/sessionExpiry";

const instance = axios.create({
  baseURL: process.env.REACT_APP_MerchantDashboard_Api_URL,
});

// Session is created at login (SPA navigation, no full reload) - read on every request.
instance.interceptors.request.use((config) => {
  const sessionId = localStorage.getItem("sessionId");
  if (sessionId) {
    config.headers.sessionId = sessionId;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      handleSessionExpired();
    }
    if (error.response?.status === 403) {
      notification.info({
        message: "You don't have permission to view this page!",
      });
    }
    return Promise.reject(error);
  }
);

export default instance;
